// Tooltip.tsx
import React from "react";
import { View, Text, StyleSheet, Image, ScrollView } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AppFontStyle } from "../../styles/AppFontStyle";

type ChooseBeltTypeTooltipProps = {
  content?: any;
  visible: boolean;
  setVisible;
  width?: any;
  maxHeight?: any;
  right?: number;
  boxViewStyle?: any;
  closeBtnMargin?: number;
  closeImage?: any;
  bottom?: any;
  tooltipStyle?: any;
};

const ChooseBeltTypeTooltip: React.FC<ChooseBeltTypeTooltipProps> = ({
  content,
  visible,
  setVisible,
  width = "auto",
  maxHeight = 500,
  right = 40,
  boxViewStyle = {},
  closeBtnMargin = 0,
  bottom = 0,
  closeImage = AppImages.icCloseWhiteSvg,
  tooltipStyle,
}) => {
  if (!visible) return null;

  return (
    <View
      style={[
        styles.tooltipContainer,
        tooltipStyle,
        {
          width: width,
          right: right,
          bottom: bottom,
          // bottom: bottom,
          zIndex: 2000,
        },
      ]}
    >
      <View style={styles.tooltip}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <Text style={AppFontStyle.SEMIBOLD_ANYBODY_16}>Choose Belt Type</Text>
          <TouchableOpacity
            onPress={() => {
              setVisible(false);
            }}
            style={{
              alignItems: "flex-end",
              padding: 5,
              backgroundColor: AppColors.gray_212222,
              borderRadius: 6,
              borderWidth: 1,
              borderColor: AppColors.grayColor_393939,
            }}
          >
            <Image
              source={closeImage}
              style={{
                height: 16,
                width: 16,
                marginBottom: closeBtnMargin,
              }}
            />
          </TouchableOpacity>
        </View>
        <View style={[styles.defaultBoxViewStyle, boxViewStyle]}>
          <ScrollView
            style={{ maxHeight: maxHeight }}
            showsVerticalScrollIndicator={false}
          >
            <Text style={styles.tooltipText}>{content}</Text>
          </ScrollView>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  defaultBoxViewStyle: {
    maxHeight: 250,
  },
  tooltipContainer: {
    position: "absolute",
    bottom: 30,
    zIndex: 1000,
    alignItems: "center",
    borderColor: AppColors.gray_5C5C5C,
    borderWidth: 1,
    borderRadius: 12,
  },
  tooltip: {
    padding: 10,
    backgroundColor: AppColors.black_18151b,
    borderRadius: 12,
  },
  tooltipText: {
    color: "white",
  },
});

export default ChooseBeltTypeTooltip;
